export const getSearchHubInitialState = () => 'default';
